module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av209-0300681159626be3af610cfd7687431b.jpg";